import script from "./InputSelectCurrency.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSelectCurrency.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__